import React, { createRef, Component, } from 'react';
import { View, StyleSheet, } from 'react-native';
const styles = StyleSheet.create({
    playerView: {
        width: '100%',
        height: '100%',
        flex: 1,
    },
});
export class PlayerView extends Component {
    playerRef = createRef();
    componentDidMount() {
        const player = this.props.player;
        if (this.playerRef.current) {
            player.setView(this.playerRef.current);
        }
    }
    render() {
        return (React.createElement(View, { style: this.props.style },
            React.createElement(View, { ref: this.playerRef, style: styles.playerView })));
    }
}
